'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const Symbol_module = require('../../../../Symbol.module-CBwbHbxh.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const SymbolSize30 = () => {
  return React__default.default.createElement(
    "svg",
    { className: Symbol_module.styles.root, width: "30", height: "30", "data-testid": "ZapierLogoSymbolSmall", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React__default.default.createElement("rect", { width: "30", height: "30", rx: "5", fill: "#FF4F00" })
  );
};

exports.SymbolSize30 = SymbolSize30;
//# sourceMappingURL=SymbolSize30.cjs.js.map
